export default __webpack_public_path__ + "static/media/warning--keep-left--g1.b5f34133.png";